import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-export",
  "use": "icon-export-usage",
  "viewBox": "0 0 13.812 13.899",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13.812 13.899\" id=\"icon-export\">\r\n  <defs>\r\n    <style>\r\n      #icon-export .cls-1 {\r\n        fill: #1890ff;\r\n      }\r\n    </style>\r\n  </defs>\r\n  <path id=\"icon-export_import\" class=\"cls-1\" d=\"M47.234,58.349V55.221h1.52v1.042H59.526V55.221h1.52v3.127Zm12.335-8.337-3.6,0V54.7h-3.6V50.1h-3.6L54.1,44.45Z\" transform=\"translate(-47.234 -44.45)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol